import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import styles from './TopBar.module.css';
import UserMenu from './UserMenu';
import ReleaseFlowDrawer from './ReleaseFlowDrawer';

const ChevRight = () => (
  <svg width={12} height={12} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m9 18 6-6-6-6" />
  </svg>
);

const ICO_BOOK = 'M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2zM22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z';

function useBreadcrumbs() {
  const location = useLocation();
  const path = location.pathname;

  if (path === '/' || path === '') return [];

  if (path.match(/^\/branches\/[^/]+$/)) {
    const version = path.split('/').pop();
    return [{ label: 'Branches', to: '/branches' }, { label: version }];
  }
  if (path.startsWith('/branches')) return [{ label: 'Branches' }];

  if (path.match(/^\/releases\/[^/]+$/)) {
    const version = path.split('/').pop();
    return [{ label: 'Releases', to: '/releases' }, { label: version }];
  }
  if (path.startsWith('/releases')) return [{ label: 'Releases' }];

  if (path.match(/^\/ops\/[^/]+$/)) {
    return [{ label: 'Operations', to: '/ops' }, { label: 'Operation' }];
  }
  if (path.startsWith('/ops')) return [{ label: 'Operations' }];

  if (path.match(/^\/cci\/[^/]+$/)) {
    return [{ label: 'CI jobs', to: '/cci' }, { label: path.split('/').pop() }];
  }
  if (path.startsWith('/cci')) return [{ label: 'CI jobs' }];

  if (path.match(/^\/task\/[^/]+$/)) {
    return [{ label: 'Operations', to: '/ops' }, { label: 'Task' }];
  }

  return [];
}

export default function TopBar({ user }) {
  const crumbs = useBreadcrumbs();
  const [guideOpen, setGuideOpen] = useState(false);

  return (
    <>
      <header className={styles.bar} role="banner">
        <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
          <span className={styles.crumbRoot}>Releases</span>
          {crumbs.map((c, i) => (
            <React.Fragment key={i}>
              <span className={styles.sep}><ChevRight /></span>
              {c.to ? (
                <Link to={c.to} className={styles.crumbLink}>{c.label}</Link>
              ) : (
                <span className={styles.crumbActive}>{c.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>

        <div className={styles.actions}>
          <button className={styles.guideBtn} onClick={() => setGuideOpen(true)}>
            <svg className={styles.guideIcon} width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d={ICO_BOOK} />
            </svg>
            Release Flow Guide
          </button>
          <UserMenu user={user} />
        </div>
      </header>

      <ReleaseFlowDrawer open={guideOpen} onClose={() => setGuideOpen(false)} />
    </>
  );
}
